import { render, staticRenderFns } from "./dj-button-delete.vue?vue&type=template&id=757b0fda&scoped=true&"
import script from "./dj-button-delete.vue?vue&type=script&lang=js&"
export * from "./dj-button-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757b0fda",
  null
  
)

export default component.exports